import { useQuery } from '@apollo/client'
import React from 'react'
import get from 'lodash/get'

import GET_LISTING_GALLERY from './gql/getListingPhotos.gql'

import MobileGallery from '../../../components/display/MobileGallery'

const ListingMobileGallery = ({ listingId, ...props }) => {
  const { loading, data } = useQuery(GET_LISTING_GALLERY, {
    variables: { listingId },
  })

  if (loading || !data) return null
  const { photos, ...listing } = get(data, 'listing')

  return <MobileGallery photos={photos} listing={listing} {...props} />
}

export default ListingMobileGallery
